function Footer() {
    return (
        <footer className="footer">
            <p className="footerText">&copy; TeachQuad</p>
        </footer>
    );
}
export default Footer;